var _circle, _rect, _path, _circle2, _circle3, _circle4, _circle5, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _circle6, _path16, _circle7, _path17, _rect4, _rect5, _rect6, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle8, _path25, _rect7, _rect8, _rect9, _rect10, _rect11, _path26, _path27, _path28, _path29, _path30, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 477,
    viewBox: "0 0 595 477",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 297.499,
    cy: 238.199,
    r: 238,
    fill: "#024F91",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.9694,
    y: 88.4397,
    width: 452.753,
    height: 297.468,
    rx: 16.7857,
    fill: "url(#paint0_linear_352_10979)",
    stroke: "#1E2B36",
    strokeWidth: 1.15763
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3906 105.225C81.3906 95.6352 89.165 87.8608 98.7551 87.8608H517.937C527.527 87.8608 535.302 95.6352 535.302 105.225V116.23H81.3906V105.225Z",
    fill: "#1E2B36"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.403,
    cy: 183.421,
    r: 7.46564,
    fill: "#024F91"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.774,
    cy: 183.421,
    r: 7.46564,
    fill: "#024F91"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.774,
    cy: 317.802,
    r: 7.46564,
    fill: "#024F91"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.403,
    cy: 317.802,
    r: 7.46564,
    fill: "#024F91"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 187.982,
    y: 184.001,
    width: 136.21,
    height: 133.224,
    stroke: "#024F91",
    strokeWidth: 1.15763
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 218.222,
    y: 209.026,
    width: 79.2785,
    height: 79.2785,
    rx: 39.6393,
    fill: "#024F91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.092 263.747L253.598 260.091C254.206 259.857 254.51 259.74 254.794 259.587C255.047 259.452 255.288 259.295 255.514 259.12C255.769 258.922 256 258.691 256.46 258.231L275.783 238.908C277.675 237.016 277.675 233.948 275.783 232.056C273.89 230.164 270.823 230.164 268.93 232.056L249.608 251.379C249.148 251.839 248.917 252.07 248.719 252.325C248.544 252.551 248.387 252.792 248.251 253.045C248.099 253.329 247.982 253.633 247.748 254.241L244.092 263.747ZM244.092 263.747L247.617 254.581C247.87 253.925 247.996 253.597 248.212 253.446C248.401 253.315 248.635 253.266 248.861 253.309C249.12 253.358 249.369 253.607 249.865 254.104L253.735 257.973C254.232 258.47 254.481 258.719 254.53 258.978C254.573 259.204 254.524 259.438 254.392 259.627C254.242 259.843 253.914 259.969 253.258 260.221L244.092 263.747Z",
    stroke: "white",
    strokeWidth: 3.13158,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 139.375H410.626",
    stroke: "#024F91",
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 180.436H410.626",
    stroke: "#024F91",
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 219.257H410.626",
    stroke: "#024F91",
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 153.559H463.632",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 164.01H463.632",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 192.381H463.632",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 204.326H463.632",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 231.201H463.632",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M357.62 243.146H463.632",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_352_10979)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.102,
    y: 296.899,
    width: 258.311,
    height: 113.478,
    rx: 3.4729,
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M276.994 332.733H330",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.994 379.021H366.582",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.994 320.79H383.006",
    stroke: "#024F91",
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M276.994 367.075H406.896",
    stroke: "#024F91",
    strokeWidth: 3.4729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.085,
    cy: 320.788,
    r: 10.4519,
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M469.604 320.611L472.342 324.522L477.426 316.31",
    stroke: "white",
    strokeWidth: 1.81914,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 474.085,
    cy: 379.021,
    r: 10.4519,
    fill: "#024F91"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M471.1 378.843L473.837 382.753L478.921 374.541",
    stroke: "white",
    strokeWidth: 1.81914,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 114.788,
    y: 180.983,
    width: 43.6972,
    height: 43.6972,
    rx: 4.08217,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.0967
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 114.788,
    y: 236.23,
    width: 43.6972,
    height: 43.6972,
    rx: 4.08217,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.0967
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 114.788,
    y: 294.461,
    width: 43.6972,
    height: 43.6972,
    rx: 4.08217,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.0967
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M127.679 193.874H142.61M135.144 193.874V211.791",
    stroke: "#1E2B36",
    strokeWidth: 2.31526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 310.037C123.2 307.528 123.2 306.274 123.688 305.316C124.118 304.473 124.803 303.788 125.646 303.358C126.604 302.87 127.859 302.87 130.367 302.87H142.909C145.418 302.87 146.673 302.87 147.631 303.358C148.474 303.788 149.159 304.473 149.588 305.316C150.077 306.274 150.077 307.528 150.077 310.037V322.579C150.077 325.088 150.077 326.342 149.588 327.301C149.159 328.143 148.474 328.829 147.631 329.258C146.673 329.746 145.418 329.746 142.909 329.746H130.367C127.859 329.746 126.604 329.746 125.646 329.258C124.803 328.829 124.118 328.143 123.688 327.301C123.2 326.342 123.2 325.088 123.2 322.579V310.037Z",
    stroke: "#1E2B36",
    strokeWidth: 2.31526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132.159 312.575L127.68 320.788H145.597L138.878 309.589L135.145 314.815L132.159 312.575Z",
    stroke: "#1E2B36",
    strokeWidth: 2.31526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.919 267.783L128.426 252.852H142.611L141.118 267.783H129.919Z",
    fill: "#1E2B36"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.611 249.866H127.68V248.373H129.919H140.371H142.611V249.866Z",
    fill: "#1E2B36"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.919 267.783L128.426 252.852H142.611L141.118 267.783H129.919Z",
    stroke: "#1E2B36",
    strokeWidth: 1.15763,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M142.611 249.866H127.68V248.373H129.919H140.371H142.611V249.866Z",
    stroke: "#1E2B36",
    strokeWidth: 1.15763,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.145,
    cy: 248.372,
    r: 2.23969,
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M119.699 157.641H114.765L120.323 140.802H126.572L132.13 157.641H127.197L123.513 145.439H123.382L119.699 157.641ZM118.778 150.997H128.052V154.418H118.778V150.997ZM138.907 157.871C137.536 157.871 136.363 157.6 135.388 157.057C134.412 156.509 133.664 155.747 133.143 154.771C132.623 153.79 132.362 152.653 132.362 151.359C132.362 150.066 132.623 148.931 133.143 147.955C133.664 146.974 134.412 146.212 135.388 145.67C136.363 145.122 137.536 144.847 138.907 144.847C140.146 144.847 141.217 145.072 142.121 145.522C143.031 145.966 143.736 146.596 144.234 147.413C144.733 148.224 144.985 149.178 144.991 150.274H140.781C140.721 149.611 140.529 149.106 140.206 148.761C139.888 148.41 139.477 148.235 138.973 148.235C138.578 148.235 138.233 148.35 137.937 148.58C137.641 148.805 137.41 149.147 137.246 149.608C137.082 150.063 136.999 150.636 136.999 151.326C136.999 152.017 137.082 152.592 137.246 153.053C137.41 153.508 137.641 153.85 137.937 154.081C138.233 154.305 138.578 154.418 138.973 154.418C139.307 154.418 139.603 154.341 139.86 154.187C140.118 154.029 140.326 153.798 140.485 153.497C140.65 153.19 140.748 152.817 140.781 152.379H144.991C144.974 153.491 144.72 154.462 144.226 155.289C143.733 156.111 143.034 156.747 142.13 157.197C141.231 157.646 140.156 157.871 138.907 157.871ZM154.395 145.012V148.301H146.074V145.012H154.395ZM147.686 141.986H152.224V153.579C152.224 153.754 152.254 153.902 152.314 154.023C152.375 154.138 152.468 154.226 152.594 154.286C152.72 154.341 152.882 154.368 153.079 154.368C153.216 154.368 153.375 154.352 153.556 154.319C153.742 154.286 153.879 154.259 153.967 154.237L154.625 157.427C154.422 157.487 154.132 157.561 153.753 157.649C153.381 157.737 152.937 157.794 152.421 157.822C151.38 157.876 150.506 157.769 149.799 157.501C149.092 157.227 148.56 156.797 148.204 156.21C147.847 155.624 147.675 154.889 147.686 154.007V141.986ZM156.247 157.641V145.012H160.785V157.641H156.247ZM158.516 143.696C157.902 143.696 157.376 143.494 156.937 143.088C156.499 142.682 156.279 142.195 156.279 141.625C156.279 141.054 156.499 140.567 156.937 140.161C157.376 139.755 157.902 139.553 158.516 139.553C159.135 139.553 159.661 139.755 160.094 140.161C160.533 140.567 160.752 141.054 160.752 141.625C160.752 142.195 160.533 142.682 160.094 143.088C159.661 143.494 159.135 143.696 158.516 143.696ZM175.825 145.012L171.582 157.641H166.32L162.078 145.012H166.847L168.886 153.365H169.017L171.056 145.012H175.825ZM177.116 157.641V145.012H181.654V157.641H177.116ZM179.385 143.696C178.771 143.696 178.245 143.494 177.806 143.088C177.368 142.682 177.148 142.195 177.148 141.625C177.148 141.054 177.368 140.567 177.806 140.161C178.245 139.755 178.771 139.553 179.385 139.553C180.004 139.553 180.53 139.755 180.963 140.161C181.402 140.567 181.621 141.054 181.621 141.625C181.621 142.195 181.402 142.682 180.963 143.088C180.53 143.494 180.004 143.696 179.385 143.696ZM191.498 145.012V148.301H183.177V145.012H191.498ZM184.789 141.986H189.327V153.579C189.327 153.754 189.357 153.902 189.417 154.023C189.478 154.138 189.571 154.226 189.697 154.286C189.823 154.341 189.985 154.368 190.182 154.368C190.319 154.368 190.478 154.352 190.659 154.319C190.845 154.286 190.982 154.259 191.07 154.237L191.728 157.427C191.525 157.487 191.235 157.561 190.856 157.649C190.484 157.737 190.04 157.794 189.524 157.822C188.483 157.876 187.609 157.769 186.902 157.501C186.195 157.227 185.663 156.797 185.307 156.21C184.95 155.624 184.778 154.889 184.789 154.007V141.986ZM199.265 157.871C197.917 157.871 196.755 157.613 195.779 157.098C194.809 156.577 194.061 155.832 193.535 154.862C193.014 153.886 192.753 152.718 192.753 151.359C192.753 150.055 193.017 148.915 193.543 147.939C194.069 146.963 194.812 146.204 195.771 145.661C196.73 145.119 197.862 144.847 199.167 144.847C200.12 144.847 200.984 144.995 201.756 145.291C202.529 145.587 203.19 146.018 203.738 146.582C204.286 147.141 204.708 147.821 205.004 148.621C205.3 149.422 205.448 150.323 205.448 151.326V152.379H194.168V149.879H201.271C201.266 149.517 201.173 149.2 200.992 148.925C200.816 148.646 200.578 148.429 200.276 148.276C199.98 148.117 199.643 148.038 199.265 148.038C198.898 148.038 198.561 148.117 198.254 148.276C197.947 148.429 197.7 148.643 197.514 148.917C197.333 149.191 197.237 149.512 197.226 149.879V152.576C197.226 152.982 197.311 153.343 197.481 153.661C197.651 153.979 197.895 154.229 198.213 154.409C198.531 154.59 198.914 154.681 199.364 154.681C199.676 154.681 199.961 154.637 200.219 154.549C200.482 154.462 200.707 154.335 200.893 154.171C201.079 154.001 201.216 153.798 201.304 153.563H205.448C205.305 154.44 204.968 155.201 204.437 155.848C203.905 156.49 203.201 156.988 202.324 157.345C201.452 157.695 200.433 157.871 199.265 157.871ZM197.588 143.433L199.167 139.75H203.047L200.581 143.433H197.588Z",
    fill: "#024F91"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 500.866,
    y: 125.426,
    width: 93.9126,
    height: 93.9126,
    rx: 9.70814,
    fill: "#024F91"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 381.91,
    y: 25.2524,
    width: 56.3476,
    height: 56.3476,
    rx: 9.70814,
    fill: "#024F91"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 128.349,
    y: 400.903,
    width: 68.8693,
    height: 68.8693,
    rx: 9.70814,
    fill: "#024F91"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 278.606,
    y: 62.8179,
    width: 68.8693,
    height: 68.8693,
    rx: 9.70814,
    fill: "#024F91"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 191.165,
    width: 68.8693,
    height: 68.8693,
    rx: 9.70814,
    fill: "#024F91"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M394.318 59.2524V47.485H397.513V56.6783H402.271V59.2524H394.318ZM414.504 53.3687C414.504 54.6788 414.249 55.7839 413.739 56.6841C413.23 57.5804 412.542 58.2603 411.677 58.7238C410.811 59.1835 409.846 59.4133 408.781 59.4133C407.708 59.4133 406.739 59.1816 405.873 58.7181C405.011 58.2508 404.326 57.5689 403.816 56.6726C403.311 55.7724 403.058 54.6711 403.058 53.3687C403.058 52.0587 403.311 50.9555 403.816 50.0591C404.326 49.159 405.011 48.479 405.873 48.0194C406.739 47.5559 407.708 47.3241 408.781 47.3241C409.846 47.3241 410.811 47.5559 411.677 48.0194C412.542 48.479 413.23 49.159 413.739 50.0591C414.249 50.9555 414.504 52.0587 414.504 53.3687ZM411.217 53.3687C411.217 52.6639 411.123 52.0702 410.935 51.5875C410.751 51.101 410.478 50.7333 410.114 50.4843C409.754 50.2315 409.309 50.1051 408.781 50.1051C408.252 50.1051 407.806 50.2315 407.442 50.4843C407.082 50.7333 406.808 51.101 406.62 51.5875C406.436 52.0702 406.344 52.6639 406.344 53.3687C406.344 54.0735 406.436 54.6692 406.62 55.1557C406.808 55.6383 407.082 56.0061 407.442 56.2589C407.806 56.5079 408.252 56.6323 408.781 56.6323C409.309 56.6323 409.754 56.5079 410.114 56.2589C410.478 56.0061 410.751 55.6383 410.935 55.1557C411.123 54.6692 411.217 54.0735 411.217 53.3687ZM426.163 47.485V59.2524H423.497L419.245 53.0699H419.176V59.2524H415.982V47.485H418.694L422.877 53.6445H422.969V47.485H426.163Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M538.154 162.756V179.595H534.339L528.255 170.748H528.156V179.595H523.585V162.756H527.466L533.451 171.57H533.583V162.756H538.154ZM539.626 162.756H544.723L548.012 169.597H548.144L551.432 162.756H556.53L550.347 174.3V179.595H545.809V174.3L539.626 162.756ZM572.564 169.071H567.927C567.894 168.687 567.807 168.339 567.664 168.027C567.527 167.714 567.335 167.446 567.089 167.221C566.848 166.991 566.554 166.815 566.209 166.695C565.864 166.569 565.472 166.506 565.033 166.506C564.266 166.506 563.616 166.692 563.085 167.065C562.559 167.437 562.158 167.972 561.884 168.668C561.616 169.364 561.481 170.2 561.481 171.176C561.481 172.206 561.619 173.069 561.893 173.765C562.172 174.456 562.575 174.977 563.101 175.328C563.627 175.673 564.26 175.846 565 175.846C565.422 175.846 565.801 175.794 566.135 175.689C566.469 175.58 566.76 175.424 567.007 175.221C567.253 175.018 567.453 174.774 567.607 174.489C567.766 174.198 567.873 173.872 567.927 173.511L572.564 173.543C572.51 174.256 572.31 174.982 571.964 175.722C571.619 176.457 571.128 177.136 570.493 177.761C569.862 178.381 569.081 178.879 568.149 179.258C567.218 179.636 566.135 179.825 564.902 179.825C563.356 179.825 561.969 179.493 560.742 178.83C559.519 178.167 558.552 177.191 557.839 175.903C557.132 174.615 556.779 173.039 556.779 171.176C556.779 169.301 557.14 167.722 557.864 166.44C558.587 165.152 559.563 164.179 560.791 163.521C562.019 162.858 563.389 162.526 564.902 162.526C565.965 162.526 566.943 162.671 567.837 162.962C568.73 163.252 569.514 163.677 570.188 164.236C570.863 164.79 571.405 165.472 571.816 166.284C572.227 167.095 572.477 168.024 572.564 169.071Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M141.385 444.818V427.98H148.653C149.903 427.98 150.997 428.227 151.934 428.72C152.871 429.213 153.6 429.907 154.121 430.8C154.642 431.694 154.902 432.738 154.902 433.933C154.902 435.139 154.633 436.183 154.096 437.065C153.565 437.948 152.816 438.627 151.852 439.104C150.892 439.581 149.772 439.819 148.489 439.819H144.148V436.268H147.568C148.105 436.268 148.563 436.174 148.941 435.988C149.325 435.796 149.618 435.525 149.821 435.174C150.029 434.823 150.133 434.41 150.133 433.933C150.133 433.45 150.029 433.039 149.821 432.699C149.618 432.354 149.325 432.091 148.941 431.91C148.563 431.724 148.105 431.631 147.568 431.631H145.957V444.818H141.385ZM158.85 444.818H153.917L159.475 427.98H165.724L171.282 444.818H166.349L162.665 432.617H162.534L158.85 444.818ZM157.93 438.175H167.204V441.595H157.93V438.175ZM172.904 444.818V427.98H180.172C181.421 427.98 182.515 428.208 183.452 428.662C184.389 429.117 185.118 429.772 185.639 430.628C186.16 431.483 186.42 432.508 186.42 433.702C186.42 434.908 186.152 435.925 185.615 436.753C185.083 437.58 184.335 438.205 183.37 438.627C182.411 439.049 181.29 439.26 180.007 439.26H175.666V435.709H179.086C179.624 435.709 180.081 435.643 180.459 435.511C180.843 435.374 181.136 435.158 181.339 434.862C181.547 434.566 181.652 434.179 181.652 433.702C181.652 433.22 181.547 432.828 181.339 432.527C181.136 432.22 180.843 431.995 180.459 431.853C180.081 431.705 179.624 431.631 179.086 431.631H177.475V444.818H172.904ZM182.77 437.09L186.979 444.818H182.013L177.902 437.09H182.77Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1613 233.226V218.152H18.6679C19.7867 218.152 20.7656 218.356 21.6047 218.763C22.4438 219.17 23.0964 219.757 23.5625 220.522C24.0287 221.288 24.2618 222.205 24.2618 223.275C24.2618 224.354 24.0213 225.265 23.5405 226.006C23.0645 226.746 22.3947 227.306 21.5311 227.684C20.6724 228.062 19.6689 228.25 18.5207 228.25H14.6344V225.071H17.6963C18.1772 225.071 18.5869 225.012 18.9255 224.894C19.269 224.771 19.5315 224.578 19.713 224.313C19.8995 224.048 19.9927 223.702 19.9927 223.275C19.9927 222.843 19.8995 222.492 19.713 222.222C19.5315 221.947 19.269 221.746 18.9255 221.619C18.5869 221.486 18.1772 221.42 17.6963 221.42H16.2537V233.226H12.1613ZM20.9938 226.307L24.7623 233.226H20.3166L16.6364 226.307H20.9938ZM40.6092 225.689C40.6092 227.367 40.2829 228.783 39.6303 229.936C38.9777 231.084 38.0969 231.955 36.9879 232.549C35.8789 233.138 34.6424 233.432 33.2783 233.432C31.9043 233.432 30.6629 233.135 29.5539 232.542C28.4498 231.943 27.5715 231.069 26.9189 229.921C26.2712 228.768 25.9473 227.357 25.9473 225.689C25.9473 224.011 26.2712 222.598 26.9189 221.449C27.5715 220.296 28.4498 219.425 29.5539 218.837C30.6629 218.243 31.9043 217.946 33.2783 217.946C34.6424 217.946 35.8789 218.243 36.9879 218.837C38.0969 219.425 38.9777 220.296 39.6303 221.449C40.2829 222.598 40.6092 224.011 40.6092 225.689ZM36.3991 225.689C36.3991 224.786 36.2788 224.026 36.0384 223.407C35.8029 222.784 35.452 222.313 34.9859 221.994C34.5246 221.67 33.9554 221.508 33.2783 221.508C32.6011 221.508 32.0294 221.67 31.5633 221.994C31.102 222.313 30.7512 222.784 30.5107 223.407C30.2752 224.026 30.1574 224.786 30.1574 225.689C30.1574 226.592 30.2752 227.355 30.5107 227.978C30.7512 228.596 31.102 229.067 31.5633 229.391C32.0294 229.71 32.6011 229.87 33.2783 229.87C33.9554 229.87 34.5246 229.71 34.9859 229.391C35.452 229.067 35.8029 228.596 36.0384 227.978C36.2788 227.355 36.3991 226.592 36.3991 225.689ZM42.5027 218.152H47.5961L51.0996 226.69H51.2763L54.7798 218.152H59.8732V233.226H55.8691V224.511H55.7514L52.395 233.108H49.9808L46.6245 224.452H46.5067V233.226H42.5027V218.152Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M288.241 90.4447V86.7613H302.876V90.4447H297.811V103.6H293.306V90.4447H288.241ZM303.906 86.7613H309.003L312.292 93.6019H312.423L315.712 86.7613H320.81L314.627 98.3048V103.6H310.088V98.3048L303.906 86.7613ZM337.436 95.1805C337.436 97.055 337.072 98.6364 336.343 99.9245C335.614 101.207 334.63 102.18 333.391 102.843C332.152 103.501 330.771 103.83 329.247 103.83C327.713 103.83 326.326 103.498 325.087 102.835C323.854 102.166 322.873 101.191 322.144 99.908C321.42 98.6199 321.058 97.0441 321.058 95.1805C321.058 93.3059 321.42 91.7273 322.144 90.4447C322.873 89.1566 323.854 88.1837 325.087 87.526C326.326 86.8627 327.713 86.5311 329.247 86.5311C330.771 86.5311 332.152 86.8627 333.391 87.526C334.63 88.1837 335.614 89.1566 336.343 90.4447C337.072 91.7273 337.436 93.3059 337.436 95.1805ZM332.733 95.1805C332.733 94.1719 332.599 93.3223 332.33 92.6317C332.067 91.9356 331.675 91.4094 331.155 91.0531C330.64 90.6914 330.004 90.5105 329.247 90.5105C328.491 90.5105 327.852 90.6914 327.332 91.0531C326.816 91.4094 326.424 91.9356 326.156 92.6317C325.893 93.3223 325.761 94.1719 325.761 95.1805C325.761 96.189 325.893 97.0413 326.156 97.7375C326.424 98.4281 326.816 98.9543 327.332 99.316C327.852 99.6723 328.491 99.8505 329.247 99.8505C330.004 99.8505 330.64 99.6723 331.155 99.316C331.675 98.9543 332.067 98.4281 332.33 97.7375C332.599 97.0413 332.733 96.189 332.733 95.1805Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_352_10979",
    x: 248.471,
    y: 296.899,
    width: 267.573,
    height: 122.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.63053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.31526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_352_10979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_352_10979",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_352_10979",
    x1: 98.3651,
    y1: 322.675,
    x2: 524.143,
    y2: 191.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityEditIcon);
export default __webpack_public_path__ + "static/media/activity-edit-icon.e5836a28.svg";
export { ForwardRef as ReactComponent };